import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function Nav() {
  const [time, setTime] = useState('');

  useEffect(() => {
    function tick() {
      const now = new Date().toLocaleString('en-US', {
        timeZone: 'America/Los_Angeles',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true
      });
      setTime(now);
    }
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <nav>
      <Link to="/" className="logo">lakeshore<sup>™</sup></Link>
      <div className="nav-clock">Los Angeles — {time}</div>
      <Link to="/contact" className="nav-cta">GET IN TOUCH →</Link>
    </nav>
  );
}
